import { z } from 'zod';

/**
 * Notizen zu einem Projekt (Verlauf, z. B. Referenz-Vertrieb): reiner
 * Freitext-Verlauf, ohne Typ/Fälligkeit/Erledigt (anders als CRM-Activities).
 * Zeitstempel/Autor kommen aus den Standard-Audit-Spalten — `createdByName`
 * ist ein Anzeigename-Snapshot, serverseitig aus `createdBy` aufgelöst.
 */
export const createProjectNoteSchema = z.object({
  content: z.string().trim().min(1).max(20000),
});
export type CreateProjectNoteInput = z.infer<typeof createProjectNoteSchema>;

export const updateProjectNoteSchema = createProjectNoteSchema.partial();
export type UpdateProjectNoteInput = z.infer<typeof updateProjectNoteSchema>;

export const projectNoteResponseSchema = z.object({
  id: z.string().uuid(),
  projectId: z.string().uuid(),
  content: z.string(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  createdBy: z.string().uuid(),
  /** Anzeigename des Autors; null, falls der Nutzer inzwischen unbekannt/inaktiv ist. */
  createdByName: z.string().nullable(),
});
export type ProjectNoteResponse = z.infer<typeof projectNoteResponseSchema>;
